import React from 'react';
import { getDomain } from 'src/tools/getDomain';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useProvider } from 'src/state/provider';
import { useModal } from 'src/state/modal';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';

export const RecentSearchFlyout = () => {
  const { user } = useUser.state();
  const { provider } = useProvider.state();
  const { modals, modalData } = useModal?.state ? useModal?.state() : {};
  const { toggleModal } = useModal?.actions ? useModal?.actions() : {};

  const newSearch = 'recent-search';

  const isModalOpen = !!modals[newSearch];
  const domain = getDomain('sde-eligibility', 3100);
  const handleClose = () => {
    toggleModal({ key: 'recent-search', isOpen: false });
  };
  return (
    <React.Fragment>
      <Drawer
        isOpen={isModalOpen}
        onClose={handleClose}
        position="right"
        data-testid="eligibility-recent-eligbility-search-flyout"
        title="Recent Search Results"
        size="500px"
      >
        <abyss-parcel
          user={JSON.stringify(user)}
          provider={JSON.stringify(provider)}
          scriptdomain={domain}
          import="eligibility-recent-eligbility-search-flyout@dev"
        />
      </Drawer>
    </React.Fragment>
  );
};
